import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import '../../styles/Footer.css';

function Footer() {
  const [isVisible, setIsVisible] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  // Check if device is mobile based on screen width
  useEffect(() => {
    const checkDeviceType = () => {
      setIsMobile(window.innerWidth < 768);
    };
    
    // Set initial values
    checkDeviceType();
    
    // Update on resize
    window.addEventListener('resize', checkDeviceType);
    return () => window.removeEventListener('resize', checkDeviceType);
  }, []);

  // Handle scroll behavior (only important on mobile)
  useEffect(() => {
    // Don't bother with scroll detection on desktop
    if (!isMobile) {
      setIsVisible(true);
      return;
    }
    
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      const documentHeight = document.documentElement.scrollHeight;
      const windowHeight = window.innerHeight;
      
      // Show footer when near bottom of the page
      if (windowHeight + currentScrollY >= documentHeight - 50) {
        setIsVisible(true);
      } 
      // Hide footer when at the top of the page
      else if (currentScrollY < 100) {
        setIsVisible(false);
      }
      // Otherwise maintain current visibility state
    };

    // Set initial state
    handleScroll();
    
    // Add event listener for scroll
    window.addEventListener('scroll', handleScroll, { passive: true });
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [isMobile]);
  
  return (
    <footer className={`footer ${isVisible ? 'footer--visible' : 'footer--hidden'}`}>
      <p>© 2025 One Dream Cafe |</p>
      <Link to="/privacy">Privacy Notice</Link>
    </footer>
  );
}

export default Footer;